import { useMemo, useState } from 'react';
import { topics } from '@/mocks/topics';

const filters = [
  { key: 'all', label: '全部专题' },
  { key: 'hot', label: '收录最多' },
  { key: 'deep', label: '精选深度' },
];

export default function TopicsExplorer() {
  const [active, setActive] = useState('all');

  const list = useMemo(() => {
    if (active === 'hot') return [...topics].sort((a, b) => b.count - a.count);
    if (active === 'deep') return topics.filter((t) => t.count <= 250);
    return topics;
  }, [active]);

  return (
    <section id="topic-grid" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">专题合集</h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              每个专题横向聚合不同频道的相关报道。切换下方视图，可以按收录规模或深度程度重新排列。
            </p>
          </div>
          <div className="inline-flex w-fit rounded-full bg-background-100 border border-background-300/60 px-1 py-1">
            {filters.map((f) => (
              <button
                key={f.key}
                type="button"
                onClick={() => setActive(f.key)}
                aria-pressed={active === f.key}
                className={`px-4 py-2 rounded-full text-sm font-label transition-colors whitespace-nowrap ${
                  active === f.key ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 md:gap-6">
          {list.map((topic) => (
            <article
              key={topic.slug}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-100/50 transition-colors hover:border-primary-300"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={topic.image}
                  alt={`${topic.name} 专题配图`}
                  title={`${topic.name} - 爆料官网专题分类`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col gap-3 p-5 md:p-6 grow">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                    <i className={`${topic.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{topic.name}</h3>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {topic.keywords.map((k) => (
                    <span key={k} className="text-xs font-label px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900">
                      {k}
                    </span>
                  ))}
                </div>
                <div className="mt-auto pt-4 border-t border-background-300/60 flex items-center justify-between">
                  <span className="text-xs font-label text-foreground-500">收录 {topic.count} 篇</span>
                  <a
                    href="#topic-notes"
                    className="inline-flex items-center gap-1 text-xs font-label text-primary-600 hover:text-primary-700 transition-colors"
                  >
                    查看选题说明
                    <i className="ri-arrow-down-s-line" aria-hidden="true" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <div className="mt-8 rounded-lg border border-background-300/60 bg-background-100/60 px-6 py-14 text-center">
            <i className="ri-links-line text-3xl text-foreground-400" aria-hidden="true" />
            <p className="mt-3 text-sm text-foreground-600">该视图下暂无专题，切换其他视图查看。</p>
          </div>
        )}
      </div>
    </section>
  );
}